import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {AddressLine, SEPARATOR} from '../../../../../../../model/address-line';
import {TranslateService} from '@ngx-translate/core';
import {AddressService} from '../../../../../../../services/apiServices/business/address.service';
import {CommonService} from '../../../../../../../services/apiServices/business/common.service';

@Component({
  selector: 'app-address-labels',
  templateUrl: './address-labels.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AddressLabelsComponent implements OnInit {
  @Input() public addressData: AddressLine[];
  @Input() public legend: string;
  @Input() public country: string;
  @Output() public showDialog: EventEmitter<boolean>;

  frenchAddressLines: AddressLine[];
  englishAddressLines: AddressLine[];
  public addressItemsFrenchLabels: any;
  public addressItemsEnglishLabels: any;
  frenchTranslationLabel: string;
  labelsSavedTitle: string;
  labelsSavedDetail: string;
  englishTranslationLabel: string;
  public countryFrenchLabel: any;
  public countryEnglishLabel: any;

  constructor(private translateService: TranslateService, private addressService: AddressService, private commonService: CommonService) {
    this.showDialog = new EventEmitter();
  }

  ngOnInit(): void {
    this.addressItemsFrenchLabels = JSON.parse(this.addressService.getLabelsForLang('fr'));
    this.addressItemsEnglishLabels = JSON.parse(this.addressService.getLabelsForLang('en'));
    if (this.addressItemsFrenchLabels && this.addressItemsEnglishLabels) {
      this.initData();
    }
    else {
      this.addressService.labelsReady.subscribe(val => {
        if ('FR' === val || 'fr' === val) {
          this.addressItemsFrenchLabels = JSON.parse(this.addressService.getLabelsForLang('fr'));
        }
        if ('EN' === val || 'en' === val) {
          this.addressItemsEnglishLabels = JSON.parse(this.addressService.getLabelsForLang('en'));
        }
        if (this.addressItemsFrenchLabels && this.addressItemsEnglishLabels) {
          this.initData();
        }
      });
    }
    this.translateService.get('ADDRESS_LABELS_COMPONENT.ENGLISH_TRANSLATION').subscribe(value => {
      this.englishTranslationLabel = value;
    });
    this.translateService.get('ADDRESS_LABELS_COMPONENT.FRENCH_TRANSLATION').subscribe(value => {
      this.frenchTranslationLabel = value;
    });
    this.translateService.get('ADDRESS_LABELS_COMPONENT.SAVED_TRANSLATION').subscribe(value => {
      this.labelsSavedDetail = value;
    });
    this.translateService.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe(value => {
      this.labelsSavedTitle = value;
    });
  }
  private initData(): void {
    if (this.addressItemsFrenchLabels[this.country]) {
      this.countryFrenchLabel = this.addressItemsFrenchLabels[this.country];
    } else {
      this.countryFrenchLabel = {};
    }
    if (this.addressItemsEnglishLabels[this.country]) {
      this.countryEnglishLabel = this.addressItemsEnglishLabels[this.country];
    } else {
      this.countryEnglishLabel = {};
    }
    this.frenchAddressLines = [];
    this.englishAddressLines = [];
    for (const addressLine of this.addressData) {
      if (addressLine.sElemCountry !== 'Y') {
        const frenchLine = new AddressLine(addressLine);
        const englishLine = new AddressLine(addressLine);
        let key = addressLine.sDataLib;
        if (key && key.indexOf('country.' + this.country) >= 0) {
          key = key.replace('country.' + this.country + '.', '');
        }
        if (this.countryFrenchLabel[key]) {
          frenchLine.sDataLibValue = this.countryFrenchLabel[key];
        }
        else {
          frenchLine.sDataLibValue = frenchLine.sDataLib;
        }
        if (this.countryEnglishLabel[key]) {
          englishLine.sDataLibValue = this.countryEnglishLabel[key];
        }
        else {
          englishLine.sDataLibValue = englishLine.sDataLib;
        }
        this.frenchAddressLines.push(frenchLine);
        this.englishAddressLines.push(englishLine);
      }
    }
  }
  public saveLabels(): void {
    const fr = {
    };
    const en = {
    };
    for (const line of this.frenchAddressLines) {
      let key = line.sDataLib;
      if (key && key.indexOf('country.' + this.country) >= 0) {
        key = key.replace('country.' + this.country + '.', '');
      }
      fr[key] = line.sDataLibValue;
    }
    for (const line of this.englishAddressLines) {
      let key = line.sDataLib;
      if (key && key.indexOf('country.' + this.country) >= 0) {
        key = key.replace('country.' + this.country + '.', '');
      }
      en[key] = line.sDataLibValue;
    }
    const data: any = {
      fr: {},
      en: {}
    };
    data['fr'][this.country] = fr;
    data['en'][this.country] = en;
    this.addressService.saveLabelsForCountry(data).subscribe(saved => {
      if (saved) {
        this.commonService.addToast({
          life: 3000,
          severity: 'success',
          summary: this.labelsSavedTitle,
          detail: this.labelsSavedDetail
        });
        this.closeComponent();
      }
    });
  }
  public closeComponent(): void {
    this.showDialog.emit(false);
  }
  public validForm(): boolean {
    for (const line of this.frenchAddressLines) {
      if (!this.isValidLine(line)) {
        return false;
      }
    }
    for (const line of this.englishAddressLines) {
      if (!this.isValidLine(line)) {
        return false;
      }
    }
    return true;
  }
  public isValidLine(line: AddressLine): boolean {
    if (line.sDataLib === SEPARATOR) {
      return true;
    }
    if (line.sDataLibValue !== '' && line.sDataLibValue !== line.sDataLib) {
      return true;
    }
    return false;
  }
}
